"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelWishlist = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const UserPanelLayout_1 = require("./views/UserPanelLayout");
const UserPanelWishlistView_1 = require("./views/UserPanelWishlistView");
const __1 = require("..");
function UserPanelWishlist({ logo, }) {
    const { products, loading } = (0, __1.useWishlist)();
    return ((0, jsx_runtime_1.jsx)(UserPanelLayout_1.UserPanelLayout, Object.assign({ logo: logo }, { children: (0, jsx_runtime_1.jsx)(UserPanelWishlistView_1.UserPanelWishlistView, { loading: loading, products: products }) })));
}
exports.UserPanelWishlist = UserPanelWishlist;
